import {InjectionToken} from '@angular/core';
import {
  IActiveCartService,
  IAddToCartEventService,
  IAuthService,
  ICampaignTrackingService,
  ICartDecoratorErrorHandlingService,
  IConfigService,
  ICountrySelectorService,
  IDefaultModalService,
  ISupportFormService,
  ITransactionTypeService,
} from '../interfaces';
import {AppConfig, AttributeValueHandler, FeatureToggleConfig} from '../models';
import {withType} from './create-token';

/**
 * This map lists all the available service providers which have to be used in the scope of this library.
 * A service provider is an Angular service instance or something comparable.
 */
export const serviceProviderMap = {
  // SERVICE PROVIDER
  CART_DECORATOR_ERROR_HANDLING_SERVICE_PROVIDER: withType<ICartDecoratorErrorHandlingService>(),
  COUNTRY_SELECTOR_SERVICE_PROVIDER: withType<ICountrySelectorService>(),
  AUTH_SERVICE_PROVIDER: withType<IAuthService>(),
  CONFIG_SERVICE_PROVIDER: withType<IConfigService>(),
  TRANSACTION_TYPE_SERVICE_PROVIDER: withType<ITransactionTypeService>(),
  ACTIVE_CART_SERVICE_PROVIDER: withType<IActiveCartService>(),
  DEFAULT_MODAL_SERVICE_PROVIDER: withType<IDefaultModalService>(),

  // ATTRIBUTE HANDLER
  ATTRIBUTE_VALUE_HANDLER: withType<AttributeValueHandler>(true),
} as const;

/**
 * This map lists all available value providers which have to be used in the scope of this library.
 * A value provider is not a class but a constant value, e.g. a config.
 */
export const valueProviderMap = {
  APP_CONFIG: withType<InjectionToken<AppConfig> | AppConfig>(),
  FEATURE_TOGGLES: withType<FeatureToggleConfig>(),
  PRODUCT_SEARCH_FIELDS_CONFIG: withType<string>(),
  VARIANT_PRODUCT_SEARCH_FIELDS_CONFIG: withType<string>(),
} as const;

/**
 * This map lists all optional service providers which can be used in the scope of this library.
 * An optional service provider is an Angular service instance or something comparable.
 */
export const optionalServiceProviderMap = {
  ADD_TO_CART_EVENT_SERVICE_PROVIDER: withType<IAddToCartEventService>(),
  CAMPAIGN_TRACKING_SERVICE_PROVIDER: withType<ICampaignTrackingService>(),
  SUPPORT_FORM_SERVICE_PROVIDER: withType<ISupportFormService>(),
} as const;
